@if (material) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="educationalLevels">
        {{ "forms.educationalResource.educationalDetails.educationalLevels.label" | translate }}*
        <span class="visually-hidden">({{ "forms.common.required" | translate }})</span>
      </label>
      <app-tooltip-button key="forms.educationalResource.educationalDetails.educationalLevels.tooltip" variant="help"></app-tooltip-button>
      <ng-select
        [items]="educationalLevels"
        [multiple]="true"
        [closeOnSelect]="false"
        bindLabel="value"
        groupBy="children"
        id="educationalLevels"
        labelForId="educationalLevels"
        formControlName="educationalLevels"
        (change)="educationalLevelsChange($event)">
        <ng-template ng-optgroup-tmp let-item="item">{{ item.value }}</ng-template>
        <ng-template ng-option-tmp let-item="item">{{ item.value }}</ng-template>
      </ng-select>
    </div>
    <!--/educational levels-->
    @if (hasEarlyChildhoodEducation) {
      <h3>{{ "forms.educationalResource.educationalDetails.earlyChildhoodEducation.title" | translate }}</h3>
      <div class="form-group">
        <label for="earlyChildhoodEducationSubjects">
          {{ "forms.educationalResource.educationalDetails.earlyChildhoodEducation.inputs.subjects.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.educationalDetails.earlyChildhoodEducation.inputs.subjects.tooltip" variant="help"></app-tooltip-button>
        <ng-select
          aoeAlignmentTagDedupe
          [items]="[]"
          [multiple]="true"
          [addTag]="addEarlyChildhoodEducationSubject"
          bindLabel="targetName"
          id="earlyChildhoodEducationSubjects"
          labelForId="earlyChildhoodEducationSubjects"
          formControlName="earlyChildhoodEducationSubjects"
        aria-describedby="early-subjects-help"></ng-select>
        <small id="early-subjects-help" class="form-text text-muted">
          {{ "forms.helpTexts.multipleItems" | translate }}
        </small>
      </div>
      <div class="form-group">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="suitsAllEarlyChildhoodSubjects"
            formControlName="suitsAllEarlyChildhoodSubjects" />
          <label class="form-check-label" for="suitsAllEarlyChildhoodSubjects">
            {{ "forms.educationalResource.educationalDetails.common.suitsAllSubjects" | translate }}
          </label>
        </div>
      </div>
      <div class="form-group">
        <label for="earlyChildhoodEducationObjectives">
          {{ "forms.educationalResource.educationalDetails.earlyChildhoodEducation.inputs.objectives.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.educationalDetails.earlyChildhoodEducation.inputs.objectives.tooltip" variant="help"></app-tooltip-button>
        <ng-select
          aoeAlignmentTagDedupe
          [items]="[]"
          [multiple]="true"
          [addTag]="addEarlyChildhoodEducationObjective"
          bindLabel="targetName"
          id="earlyChildhoodEducationObjectives"
          labelForId="earlyChildhoodEducationObjectives"
          formControlName="earlyChildhoodEducationObjectives"
        aria-describedby="early-objectives-help"></ng-select>
        <small id="early-objectives-help" class="form-text text-muted">
          {{ "forms.helpTexts.multipleItems" | translate }}
        </small>
      </div>
      <div class="form-group">
        <label for="earlyChildhoodEducationFramework">
          {{ "forms.educationalResource.educationalDetails.earlyChildhoodEducation.inputs.framework.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.educationalDetails.earlyChildhoodEducation.inputs.framework.tooltip" variant="help"></app-tooltip-button>
        <input
          type="text"
          class="form-control"
          id="earlyChildhoodEducationFramework"
          formControlName="earlyChildhoodEducationFramework"
        [ngClass]="{
          'is-invalid':
            earlyChildhoodEducationFrameworkCtrl.invalid &&
            (earlyChildhoodEducationFrameworkCtrl.dirty || earlyChildhoodEducationFrameworkCtrl.touched || submitted)
        }" />
        @if (
          earlyChildhoodEducationFrameworkCtrl.invalid &&
          (earlyChildhoodEducationFrameworkCtrl.dirty || earlyChildhoodEducationFrameworkCtrl.touched || submitted)
          ) {
          <div
            class="invalid-feedback">
            @if (earlyChildhoodEducationFrameworkCtrl.errors.invalidCharacters) {
              <div>
                {{ "forms.errors.textInput.characters" | translate }}
              </div>
            }
            @if (earlyChildhoodEducationFrameworkCtrl.errors.maxlength) {
              <div>
                {{ "forms.errors.common.maxLength" | translate: { maxLength:
                earlyChildhoodEducationFrameworkCtrl.errors.maxlength.requiredLength } }}
              </div>
            }
          </div>
        }
      </div>
    }
    <!--/early childhood education-->
    @if (hasPrePrimaryEducation) {
      <h3>{{ "forms.educationalResource.educationalDetails.prePrimaryEducation.title" | translate }}</h3>
      <div class="form-group">
        <label for="prePrimaryEducationSubjects">
          {{ "forms.educationalResource.educationalDetails.prePrimaryEducation.inputs.subjects.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.educationalDetails.prePrimaryEducation.inputs.subjects.tooltip" variant="help"></app-tooltip-button>
        <ng-select
          aoeAlignmentTagDedupe
          [items]="[]"
          [multiple]="true"
          [addTag]="addPrePrimaryEducationSubject"
          bindLabel="targetName"
          id="prePrimaryEducationSubjects"
          labelForId="prePrimaryEducationSubjects"
          formControlName="prePrimaryEducationSubjects"
        aria-describedby="pre-subjects-help"></ng-select>
        <small id="pre-subjects-help" class="form-text text-muted">
          {{ "forms.helpTexts.multipleItems" | translate }}
        </small>
      </div>
      <div class="form-group">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="suitsAllPrePrimarySubjects"
            formControlName="suitsAllPrePrimarySubjects" />
          <label class="form-check-label" for="suitsAllPrePrimarySubjects">
            {{ "forms.educationalResource.educationalDetails.common.suitsAllSubjects" | translate }}
          </label>
        </div>
      </div>
      <div class="form-group">
        <label for="prePrimaryEducationObjectives">
          {{ "forms.educationalResource.educationalDetails.prePrimaryEducation.inputs.objectives.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.educationalDetails.prePrimaryEducation.inputs.objectives.tooltip" variant="help"></app-tooltip-button>
        <ng-select
          aoeAlignmentTagDedupe
          [items]="[]"
          [multiple]="true"
          [addTag]="addPrePrimaryEducationObjective"
          bindLabel="targetName"
          id="prePrimaryEducationObjectives"
          labelForId="prePrimaryEducationObjectives"
          formControlName="prePrimaryEducationObjectives"
        aria-describedby="pre-objectives-help"></ng-select>
        <small id="pre-objectives-help" class="form-text text-muted">
          {{ "forms.helpTexts.multipleItems" | translate }}
        </small>
      </div>
      <div class="form-group">
        <label for="prePrimaryEducationFramework">
          {{ "forms.educationalResource.educationalDetails.prePrimaryEducation.inputs.framework.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.educationalDetails.prePrimaryEducation.inputs.framework.tooltip" variant="help"></app-tooltip-button>
        <input
          type="text"
          class="form-control"
          id="prePrimaryEducationFramework"
          formControlName="prePrimaryEducationFramework"
        [ngClass]="{
          'is-invalid':
            prePrimaryEducationFrameworkCtrl.invalid &&
            (prePrimaryEducationFrameworkCtrl.dirty || prePrimaryEducationFrameworkCtrl.touched || submitted)
        }" />
        @if (
          prePrimaryEducationFrameworkCtrl.invalid &&
          (prePrimaryEducationFrameworkCtrl.dirty || prePrimaryEducationFrameworkCtrl.touched || submitted)
          ) {
          <div
            class="invalid-feedback">
            @if (prePrimaryEducationFrameworkCtrl.errors.invalidCharacters) {
              <div>
                {{ "forms.errors.textInput.characters" | translate }}
              </div>
            }
            @if (prePrimaryEducationFrameworkCtrl.errors.maxlength) {
              <div>
                {{ "forms.errors.common.maxLength" | translate: { maxLength:
                prePrimaryEducationFrameworkCtrl.errors.maxlength.requiredLength } }}
              </div>
            }
          </div>
        }
      </div>
    }
    <!--/pre-primary education-->
    @if (hasBasicStudies) {
      <h3>{{ "forms.educationalResource.educationalDetails.basicEducation.title" | translate }}</h3>
      <div class="form-group">
        <label for="basicStudySubjects">
          {{ "forms.educationalResource.educationalDetails.basicEducation.inputs.subjects.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.educationalDetails.basicEducation.inputs.subjects.tooltip" variant="help"></app-tooltip-button>
        <ng-select
          [items]="basicStudySubjects"
          [multiple]="true"
          [closeOnSelect]="false"
          bindLabel="targetName"
          groupBy="children"
          id="basicStudySubjects"
          labelForId="basicStudySubjects"
          formControlName="basicStudySubjects"
          (change)="basicStudySubjectsChange($event)">
          <ng-template ng-optgroup-tmp let-item="item">{{ item.targetName }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ item.targetName }}</ng-template>
        </ng-select>
      </div>
      <div class="form-group">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="suitsAllBasicStudySubjects"
            formControlName="suitsAllBasicStudySubjects" />
          <label class="form-check-label" for="suitsAllBasicStudySubjects">
            {{ "forms.educationalResource.educationalDetails.common.suitsAllSubjects" | translate }}
          </label>
        </div>
      </div>
      @if (hasBasicStudySubjects) {
        <div class="form-group">
          <label for="basicStudyFramework">
            {{ "forms.educationalResource.educationalDetails.basicEducation.inputs.framework.label" | translate }}
          </label>
          <app-tooltip-button key="forms.educationalResource.educationalDetails.basicEducation.inputs.framework.tooltip" variant="help"></app-tooltip-button>
          <input
            class="form-control"
            id="basicStudyFramework"
            formControlName="basicStudyFramework"
          [ngClass]="{
            'is-invalid':
              basicStudyFrameworkCtrl.invalid &&
              (basicStudyFrameworkCtrl.dirty || basicStudyFrameworkCtrl.touched || submitted)
          }" />
          @if (
            basicStudyFrameworkCtrl.invalid &&
            (basicStudyFrameworkCtrl.dirty || basicStudyFrameworkCtrl.touched || submitted)
            ) {
            <div
              class="invalid-feedback">
              @if (basicStudyFrameworkCtrl.errors.invalidCharacters) {
                <div>
                  {{ "forms.errors.textInput.characters" | translate }}
                </div>
              }
              @if (basicStudyFrameworkCtrl.errors.maxlength) {
                <div>
                  {{ "forms.errors.common.maxLength" | translate: { maxLength:
                  basicStudyFrameworkCtrl.errors.maxlength.requiredLength } }}
                </div>
              }
            </div>
          }
        </div>
        <!--/basic education framework-->
        <div class="form-group">
          <label for="basicStudyObjectives">
            {{ "forms.educationalResource.educationalDetails.basicEducation.inputs.objectives.label" | translate }}*
            <span class="visually-hidden">({{ "forms.common.required" | translate }})</span>
          </label>
          <ng-select
            [items]="basicStudyObjectives"
            [multiple]="true"
            [closeOnSelect]="false"
            bindLabel="targetName"
            groupBy="parent"
            id="basicStudyObjectives"
            labelForId="basicStudyObjectives"
            formControlName="basicStudyObjectives">
            <ng-template ng-optgroup-tmp let-item="item">{{ item.parent }}</ng-template>
            <ng-template ng-option-tmp let-item="item">{{ item.targetName }}</ng-template>
          </ng-select>
        </div>
        <!--/basic education objectives-->
        <div class="form-group">
          <label for="basicStudyContents">
            {{ "forms.educationalResource.educationalDetails.basicEducation.inputs.contents.label" | translate }}*
            <span class="visually-hidden">({{ "forms.common.required" | translate }})</span>
          </label>
          <ng-select
            [items]="basicStudyContents"
            [multiple]="true"
            [closeOnSelect]="false"
            bindLabel="targetName"
            groupBy="parent"
            id="basicStudyContents"
            labelForId="basicStudyContents"
            formControlName="basicStudyContents">
            <ng-template ng-optgroup-tmp let-item="item">{{ item.parent }}</ng-template>
            <ng-template ng-option-tmp let-item="item">{{ item.targetName }}</ng-template>
          </ng-select>
        </div>
        <!--/basic education contents-->
      }
    }
    <!--/basic education-->
    <!--preparatory education-->
    @if (hasPreparatoryEducation) {
      <div class="form-group">
        <h3>{{ "forms.educationalResource.educationalDetails.preparatoryEducation.title" | translate }}</h3>
        <label for="preparatoryEducationSubjects">
          {{ "forms.educationalResource.educationalDetails.preparatoryEducation.inputs.subjects.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.educationalDetails.preparatoryEducation.inputs.subjects.tooltip" variant="help"></app-tooltip-button>
        <ng-select
          [items]="preparatorySubjects"
          [multiple]="true"
          [closeOnSelect]="false"
          bindLabel="targetName"
          id="preparatoryEducationSubjects"
          labelForId="preparatoryEducationSubjects"
          formControlName="preparatoryEducationSubjects"
        (change)="preparatoryEducationSubjectsChange($event)"></ng-select>
      </div>
      @if (hasPreparatoryEducationSubjects) {
        <div class="form-group">
          <label for="preparatoryEducationObjectives">
            {{ "forms.educationalResource.educationalDetails.preparatoryEducation.inputs.objectives.label" | translate }}
          </label>
          <app-tooltip-button key="forms.educationalResource.educationalDetails.preparatoryEducation.inputs.objectives.tooltip" variant="help"></app-tooltip-button>
          <ng-select
            [items]="preparatoryObjectives"
            [multiple]="true"
            [closeOnSelect]="false"
            bindLabel="targetName"
            groupBy="parent"
            id="preparatoryEducationObjectives"
            labelForId="preparatoryEducationObjectives"
          formControlName="preparatoryEducationObjectives"></ng-select>
        </div>
      }
    }
    <!--/preparatory education-->
    @if (hasUpperSecondarySchool) {
      <h3>{{ "forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.title" | translate }}</h3>
      <div class="form-group">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="currentUpperSecondarySchoolSelected"
            formControlName="currentUpperSecondarySchoolSelected" />
          <label class="form-check-label" for="currentUpperSecondarySchoolSelected">
            {{ "forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.selection.current" | translate
            }}
          </label>
        </div>
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="newUpperSecondarySchoolSelected"
            formControlName="newUpperSecondarySchoolSelected" />
          <label class="form-check-label" for="newUpperSecondarySchoolSelected">
            {{ "forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.selection.new" | translate }}
          </label>
        </div>
      </div>
      @if (currentUpperSecondarySchoolSelected.value === true) {
        <h4>
          {{ "forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.selection.current" | translate }}
        </h4>
        <div class="form-group">
          <label for="upperSecondarySchoolSubjectsOld">
            {{ "forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.new.subjects.label" |
            translate }}
          </label>
          <app-tooltip-button key="forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.subjects.tooltip" variant="help"></app-tooltip-button>
          <ng-select
            [items]="upperSecondarySchoolSubjectsOld"
            [multiple]="true"
            [closeOnSelect]="false"
            bindLabel="targetName"
            id="upperSecondarySchoolSubjectsOld"
            groupBy="parent"
            labelForId="upperSecondarySchoolSubjectsOld"
            formControlName="upperSecondarySchoolSubjectsOld"
            (change)="upperSecondarySchoolSubjectsOldChange($event)">
            <ng-template ng-optgroup-tmp let-item="item">{{ item.parent }}</ng-template>
          </ng-select>
        </div>
        <!--upperSecondarySubjectsOld-->
        @if (upperSecondarySchoolCoursesOld?.length > 0 || upperSecondarySchoolCoursesOldCtrl.value?.length > 0) {
          <div class="form-group">
            <label for="upperSecondarySchoolCoursesOld">
              {{ "forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.subjects.label" |
              translate }}
            </label>
            <ng-select
              [items]="upperSecondarySchoolCoursesOld"
              [multiple]="true"
              [closeOnSelect]="false"
              bindLabel="targetName"
              id="upperSecondarySchoolCoursesOld"
              groupBy="parent"
              labelForId="upperSecondarySchoolCoursesOld"
            formControlName="upperSecondarySchoolCoursesOld"></ng-select>
          </div>
        }
        <!--upperSecondaryCoursesOld-->
        <div class="form-group">
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="suitsAllUpperSecondarySubjects"
              formControlName="suitsAllUpperSecondarySubjects" />
            <label class="form-check-label" for="suitsAllUpperSecondarySubjects">
              {{ "forms.educationalResource.educationalDetails.common.suitsAllSubjects" | translate }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <label for="upperSecondarySchoolObjectives">
            {{ "forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.objectives.label" |
            translate }}
          </label>
          <app-tooltip-button key="forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.objectives.tooltip" variant="help"></app-tooltip-button>
          <ng-select
            aoeAlignmentTagDedupe
            [items]="[]"
            [multiple]="true"
            [addTag]="addUpperSecondarySchoolObjective"
            bindLabel="targetName"
            id="upperSecondarySchoolObjectives"
            labelForId="upperSecondarySchoolObjectives"
          formControlName="upperSecondarySchoolObjectives"></ng-select>
        </div>
        <div class="form-group">
          <label for="upperSecondarySchoolFramework">
            {{ "forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.framework.label" |
            translate }}
          </label>
          <app-tooltip-button key="forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.framework.tooltip" variant="help"></app-tooltip-button>
          <input
            type="text"
            class="form-control"
            id="upperSecondarySchoolFramework"
            formControlName="upperSecondarySchoolFramework"
          [ngClass]="{
            'is-invalid':
              upperSecondarySchoolFrameworkCtrl.invalid &&
              (upperSecondarySchoolFrameworkCtrl.dirty || upperSecondarySchoolFrameworkCtrl.touched || submitted)
          }" />
          @if (
            upperSecondarySchoolFrameworkCtrl.invalid &&
            (upperSecondarySchoolFrameworkCtrl.dirty || upperSecondarySchoolFrameworkCtrl.touched || submitted)
            ) {
            <div
              class="invalid-feedback">
              @if (upperSecondarySchoolFrameworkCtrl.errors.invalidCharacters) {
                <div>
                  {{ "forms.errors.textInput.characters" | translate }}
                </div>
              }
              @if (upperSecondarySchoolFrameworkCtrl.errors.maxlength) {
                <div>
                  {{ "forms.errors.common.maxLength" | translate: { maxLength:
                  upperSecondarySchoolFrameworkCtrl.errors.maxlength.requiredLength } }}
                </div>
              }
            </div>
          }
        </div>
      }
      <!--/upper secondary school (current)-->
      @if (newUpperSecondarySchoolSelected.value === true) {
        <h4>
          {{ "forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.selection.new" | translate }}
        </h4>
        <div class="form-group">
          <label for="upperSecondarySchoolSubjectsNew">
            {{ "forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.new.subjects.label" |
            translate }}
          </label>
          <ng-select
            [items]="upperSecondarySchoolSubjectsNew"
            [multiple]="true"
            [closeOnSelect]="false"
            bindLabel="targetName"
            groupBy="parent"
            id="upperSecondarySchoolSubjectsNew"
            labelForId="upperSecondarySchoolSubjectsNew"
            formControlName="upperSecondarySchoolSubjectsNew"
            (change)="upperSecondarySchoolSubjectsNewChange($event)">
            <ng-template ng-optgroup-tmp let-item="item">{{ item.parent }}</ng-template>
          </ng-select>
        </div>
        <div class="form-group">
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="suitsAllUpperSecondarySubjectsNew"
              formControlName="suitsAllUpperSecondarySubjectsNew" />
            <label class="form-check-label" for="suitsAllUpperSecondarySubjectsNew">
              {{ "forms.educationalResource.educationalDetails.common.suitsAllSubjects" | translate }}
            </label>
          </div>
        </div>
        @if (upperSecondarySchoolModulesNew?.length > 0) {
          <div class="form-group">
            <label for="upperSecondarySchoolModulesNew">
              {{ "forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.new.modules.label" |
              translate }}*
              <span class="visually-hidden">({{ "forms.common.required" | translate }})</span>
            </label>
            <ng-select
              [items]="upperSecondarySchoolModulesNew"
              [multiple]="true"
              [closeOnSelect]="false"
              bindLabel="targetName"
              groupBy="parent"
              id="upperSecondarySchoolModulesNew"
              labelForId="upperSecondarySchoolModulesNew"
              formControlName="upperSecondarySchoolModulesNew"
            (change)="upperSecondarySchoolModulesNewChange($event)"></ng-select>
          </div>
          @if (upperSecondarySchoolObjectivesNew?.length > 0) {
            <div class="form-group">
              <label for="upperSecondarySchoolObjectivesNew">
                {{ "forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.new.objectives.label"
                | translate }}*
                <span class="visually-hidden">({{ "forms.common.required" | translate }})</span>
              </label>
              <ng-select
                [items]="upperSecondarySchoolObjectivesNew"
                [multiple]="true"
                [closeOnSelect]="false"
                bindLabel="targetName"
                groupBy="parent"
                id="upperSecondarySchoolObjectivesNew"
                labelForId="upperSecondarySchoolObjectivesNew"
              formControlName="upperSecondarySchoolObjectivesNew"></ng-select>
            </div>
          }
          @if (upperSecondarySchoolContentsNew?.length > 0) {
            <div class="form-group">
              <label for="upperSecondarySchoolContentsNew">
                {{ "forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.new.contents.label" |
                translate }}*
                <span class="visually-hidden">({{ "forms.common.required" | translate }})</span>
              </label>
              <ng-select
                [items]="upperSecondarySchoolContentsNew"
                [multiple]="true"
                [closeOnSelect]="false"
                bindLabel="targetName"
                groupBy="parent"
                id="upperSecondarySchoolContentsNew"
                labelForId="upperSecondarySchoolContentsNew"
              formControlName="upperSecondarySchoolContentsNew"></ng-select>
            </div>
          }
        }
      }
      <!--/upper secondary school (new)-->
    }
    <!--/upper secondary school-->
    @if (hasVocationalEducation) {
      <h3>{{ "forms.educationalResource.educationalDetails.vocationalEducation.title" | translate }}</h3>
      <div class="form-group">
        <label for="vocationalDegrees">
          {{ "forms.educationalResource.educationalDetails.vocationalEducation.inputs.degrees.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.educationalDetails.vocationalEducation.inputs.degrees.tooltip" variant="help"></app-tooltip-button>
        <ng-select
          [items]="vocationalDegrees"
          [multiple]="true"
          [closeOnSelect]="false"
          bindLabel="targetName"
          id="vocationalDegrees"
          labelForId="vocationalDegrees"
          formControlName="vocationalDegrees"
        (change)="vocationalDegreesChange()"></ng-select>
      </div>
      <div class="form-group">
        <label for="furtherVocationalQualifications">
          {{
          "forms.educationalResource.educationalDetails.vocationalEducation.inputs.furtherVocationalQualifications.label"
          | translate }}
        </label>
        <ng-select
          [items]="furtherVocationalQualifications"
          [multiple]="true"
          [closeOnSelect]="false"
          bindLabel="targetName"
          id="furtherVocationalQualifications"
          labelForId="furtherVocationalQualifications"
          formControlName="furtherVocationalQualifications"
        (change)="vocationalDegreesChange()"></ng-select>
      </div>
      <div class="form-group">
        <label for="specialistVocationalQualifications">
          {{
          "forms.educationalResource.educationalDetails.vocationalEducation.inputs.specialistVocationalQualifications.label"
          | translate }}
        </label>
        <ng-select
          [items]="specialistVocationalQualifications"
          [multiple]="true"
          [closeOnSelect]="false"
          bindLabel="targetName"
          id="specialistVocationalQualifications"
          labelForId="specialistVocationalQualifications"
          formControlName="specialistVocationalQualifications"
        (change)="vocationalDegreesChange()"></ng-select>
      </div>
      <div class="form-group">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="suitsAllVocationalDegrees"
            formControlName="suitsAllVocationalDegrees" />
          <label class="form-check-label" for="suitsAllVocationalDegrees">
            {{ "forms.educationalResource.educationalDetails.common.suitsAllSubjects" | translate }}
          </label>
        </div>
      </div>
      <div class="form-group">
        <label for="vocationalCommonUnits">
          {{ "forms.educationalResource.educationalDetails.vocationalEducation.inputs.commonUnits.label" | translate }}
        </label>
        <ng-select
          [items]="vocationalCommonUnits"
          [multiple]="true"
          [closeOnSelect]="false"
          bindLabel="targetName"
          groupBy="children"
          id="vocationalCommonUnits"
          labelForId="vocationalCommonUnits"
          formControlName="vocationalCommonUnits">
          <ng-template ng-optgroup-tmp let-item="item">{{ item.targetName }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ item.targetName }}</ng-template>
        </ng-select>
      </div>
      @if (hasVocationalDegrees) {
        <div class="form-group">
          <label for="vocationalUnits">
            {{ "forms.educationalResource.educationalDetails.vocationalEducation.inputs.units.label" | translate }}
          </label>
          <ng-select
            [items]="vocationalUnits"
            [multiple]="true"
            [closeOnSelect]="false"
            bindLabel="targetName"
            groupBy="parent"
            id="vocationalUnits"
            labelForId="vocationalUnits"
            formControlName="vocationalUnits"
          (change)="vocationalUnitsChange($event)"></ng-select>
        </div>
        <div class="form-group">
          <label for="vocationalRequirements">
            {{ "forms.educationalResource.educationalDetails.vocationalEducation.inputs.objectives.label" | translate }}
          </label>
          <app-tooltip-button key="forms.educationalResource.educationalDetails.vocationalEducation.inputs.objectives.tooltip" variant="help"></app-tooltip-button>
          <ng-select
            aoeAlignmentTagDedupe
            [items]="vocationalRequirements"
            [multiple]="true"
            [closeOnSelect]="false"
            [addTag]="addVocationalEducationObjective"
            bindLabel="targetName"
            id="vocationalRequirements"
            groupBy="parent"
            labelForId="vocationalRequirements"
          formControlName="vocationalRequirements"></ng-select>
        </div>
        <!--vocationalRequirements-->
      }
      <div class="form-group">
        <label for="vocationalEducationFramework">
          {{ "forms.educationalResource.educationalDetails.vocationalEducation.inputs.framework.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.educationalDetails.vocationalEducation.inputs.framework.tooltip" variant="help"></app-tooltip-button>
        <input
          type="text"
          class="form-control"
          id="vocationalEducationFramework"
          formControlName="vocationalEducationFramework"
        [ngClass]="{
          'is-invalid':
            vocationalEducationFrameworkCtrl.invalid &&
            (vocationalEducationFrameworkCtrl.dirty || vocationalEducationFrameworkCtrl.touched || submitted)
        }" />
        @if (
          vocationalEducationFrameworkCtrl.invalid &&
          (vocationalEducationFrameworkCtrl.dirty || vocationalEducationFrameworkCtrl.touched || submitted)
          ) {
          <div
            class="invalid-feedback">
            @if (vocationalEducationFrameworkCtrl.errors.invalidCharacters) {
              <div>
                {{ "forms.errors.textInput.characters" | translate }}
              </div>
            }
            @if (vocationalEducationFrameworkCtrl.errors.maxlength) {
              <div>
                {{ "forms.errors.common.maxLength" | translate: { maxLength:
                vocationalEducationFrameworkCtrl.errors.maxlength.requiredLength } }}
              </div>
            }
          </div>
        }
      </div>
    }
    <!--/vocational education-->
    @if (hasSelfMotivatedEducation) {
      <h3>{{ "forms.educationalResource.educationalDetails.selfMotivatedEducation.title" | translate }}</h3>
      <div class="form-group">
        <label for="selfMotivatedEducationSubjects">
          {{ "forms.educationalResource.educationalDetails.selfMotivatedEducation.inputs.subjects.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.educationalDetails.selfMotivatedEducation.inputs.subjects.tooltip" variant="help"></app-tooltip-button>
        <ng-select
          aoeAlignmentTagDedupe
          [items]="[]"
          [multiple]="true"
          [addTag]="addSelfMotivatedEducationSubject"
          bindLabel="targetName"
          id="selfMotivatedEducationSubjects"
          labelForId="selfMotivatedEducationSubjects"
          formControlName="selfMotivatedEducationSubjects"
        aria-describedby="self-subjects-help"></ng-select>
        <small id="self-subjects-help" class="form-text text-muted">
          {{ "forms.helpTexts.multipleItems" | translate }}
        </small>
      </div>
      <div class="form-group">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="suitsAllSelfMotivatedSubjects"
            formControlName="suitsAllSelfMotivatedSubjects" />
          <label class="form-check-label" for="suitsAllSelfMotivatedSubjects">
            {{ "forms.educationalResource.educationalDetails.common.suitsAllSubjects" | translate }}
          </label>
        </div>
      </div>
      <div class="form-group">
        <label for="selfMotivatedEducationObjectives">
          {{ "forms.educationalResource.educationalDetails.selfMotivatedEducation.inputs.objectives.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.educationalDetails.selfMotivatedEducation.inputs.objectives.tooltip" variant="help"></app-tooltip-button>
        <ng-select
          aoeAlignmentTagDedupe
          [items]="[]"
          [multiple]="true"
          [addTag]="addSelfMotivatedEducationObjective"
          bindLabel="targetName"
          id="selfMotivatedEducationObjectives"
          labelForId="selfMotivatedEducationObjectives"
          formControlName="selfMotivatedEducationObjectives"
        aria-describedby="self-objectives-help"></ng-select>
        <small id="self-objectives-help" class="form-text text-muted">
          {{ "forms.helpTexts.multipleItems" | translate }}
        </small>
      </div>
    }
    <!--/self-motivated competence development-->
    @if (hasHigherEducation) {
      <h3>{{ "forms.educationalResource.educationalDetails.higherEducation.title" | translate }}</h3>
      <div class="form-group">
        <label for="branchesOfScience">
          {{ "forms.educationalResource.educationalDetails.higherEducation.inputs.branchesOfScience.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.educationalDetails.higherEducation.inputs.branchesOfScience.tooltip" variant="help"></app-tooltip-button>
        <ng-select
          [items]="scienceBranches"
          [multiple]="true"
          [closeOnSelect]="false"
          [selectableGroup]="true"
          [selectableGroupAsModel]="false"
          groupBy="children"
          bindLabel="targetName"
          id="branchesOfScience"
          labelForId="branchesOfScience"
          formControlName="branchesOfScience">
          <ng-template ng-optgroup-tmp let-item="item">{{ item.targetName }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ item.targetName }}</ng-template>
        </ng-select>
      </div>
      <div class="form-group">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="suitsAllBranches" formControlName="suitsAllBranches" />
          <label class="form-check-label" for="suitsAllBranches">
            {{ "forms.educationalResource.educationalDetails.common.suitsAllSubjects" | translate }}
          </label>
        </div>
      </div>
      <div class="form-group">
        <label for="scienceBranchObjectives">
          {{ "forms.educationalResource.educationalDetails.higherEducation.inputs.objectives.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.educationalDetails.higherEducation.inputs.objectives.tooltip" variant="help"></app-tooltip-button>
        <ng-select
          aoeAlignmentTagDedupe
          [items]="[]"
          [multiple]="true"
          [addTag]="addScienceBranchObjectives"
          bindLabel="targetName"
          id="scienceBranchObjectives"
          labelForId="scienceBranchObjectives"
          formControlName="scienceBranchObjectives"
        aria-describedby="higher-objectives-help"></ng-select>
        <small id="higher-objectives-help" class="form-text text-muted">
          {{ "forms.helpTexts.multipleItems" | translate }}
        </small>
      </div>
      <div class="form-group">
        <label for="higherEducationFramework">
          {{ "forms.educationalResource.educationalDetails.higherEducation.inputs.framework.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.educationalDetails.higherEducation.inputs.framework.tooltip" variant="help"></app-tooltip-button>
        <input
          type="text"
          class="form-control"
          id="higherEducationFramework"
          formControlName="higherEducationFramework"
        [ngClass]="{
          'is-invalid':
            higherEducationFrameworkCtrl.invalid &&
            (higherEducationFrameworkCtrl.dirty || higherEducationFrameworkCtrl.touched || submitted)
        }" />
        @if (
          higherEducationFrameworkCtrl.invalid &&
          (higherEducationFrameworkCtrl.dirty || higherEducationFrameworkCtrl.touched || submitted)
          ) {
          <div
            class="invalid-feedback">
            @if (higherEducationFrameworkCtrl.errors.invalidCharacters) {
              <div>
                {{ "forms.errors.textInput.characters" | translate }}
              </div>
            }
            @if (higherEducationFrameworkCtrl.errors.maxlength) {
              <div>
                {{ "forms.errors.common.maxLength" | translate: { maxLength:
                higherEducationFrameworkCtrl.errors.maxlength.requiredLength } }}
              </div>
            }
          </div>
        }
      </div>
    }
    <!--/higher education-->
    <div class="row form-buttons">
      <div class="col">
        <button type="button" class="btn btn-gray" (click)="previous()">{{ "forms.common.previous" | translate }}</button>
      </div>
      <div class="col-auto">
        <button type="reset" class="btn btn-cancel" (click)="abort()">{{ "forms.common.abort" | translate }}</button>
      </div>
      <div class="col-auto">
        <button type="submit" class="btn btn-blue">{{ "forms.common.next" | translate }}</button>
      </div>
    </div>
  </form>
}
